import buildQuery from "odata-query";
import axiosDmsInstance from './axiosDmsInstance';
import { getDateTimeString, handleApiError } from '../../common/util';
import { IClockingHistoryAttendance, IClockingHistoryLabour } from '../../models/dms/clocking.model';
import { fetchOdataAll } from '../../common/odataUtil';
import moment from 'moment';

export const getAttendanceClockingHistory = async (techCode: string, date: Date) => {
  try {
    const requestdate = moment(date);
    const startDate = getDateTimeString(requestdate.startOf('day').toDate());
    const endDate = getDateTimeString(requestdate.endOf('day').toDate());

    const url = `/api/common/technician/v1/attendance/list`;
    let options = {
      '$inlinecount': 'allpages',
      startDate,
      endDate
    } as any;

    let filter = {
      'TechCode': {
        eq: techCode
      },
      'StartDateTime': {
        ge: {
          type: 'raw', value: `datetime'${startDate}'`
        },
        le: {
          type: 'raw', value: `datetime'${endDate}'`
        }
      },
    };

    const query = buildQuery({ filter: filter });
    const response = await fetchOdataAll<IClockingHistoryAttendance>(axiosDmsInstance, `${url}/${query}`, options);

    return response.data;
  } catch (err: any) {
    return handleApiError('getAttendanceClockingHistory', err);
  }
};

export const getLabourClockingHistory = async (techCode: string, date: Date) => {
  try {
    const requestdate = moment(date);
    const startDate = getDateTimeString(requestdate.startOf('day').toDate());
    const endDate = getDateTimeString(requestdate.endOf('day').toDate());

    const url = `/api/common/technician/v1/labour/list`;
    let options = {
      '$inlinecount': 'allpages',
      startDate,
      endDate
    } as any;

    let filter = {
      'TechCode': {
        eq: techCode
      },
      'StartDateTime': {
        ge: {
          type: 'raw', value: `datetime'${startDate}'`
        },
        le: {
          type: 'raw', value: `datetime'${endDate}'`
        }
      },
    };

    const query = buildQuery({ filter: filter });
    const response = await fetchOdataAll<IClockingHistoryLabour>(axiosDmsInstance, `${url}/${query}`, options);

    return response.data;
  } catch (err: any) {
    return handleApiError('getLabourClockingHistory', err);
  }
};